import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Cookie } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";

const KEY = "synrise-cookie-ok";
const seen = () => {
  try { return localStorage.getItem(KEY) === "1"; } catch (e) { return false; }
};

export const CookieNotice = () => {
  const { t } = useLang();
  const { pathname } = useLocation();
  const [open, setOpen] = useState(() => !seen());

  const accept = () => {
    try { localStorage.setItem(KEY, "1"); } catch (e) {}
    setOpen(false);
  };

  return (
    <AnimatePresence>
      {open && !pathname.startsWith("/admin") && (
        <motion.div
          data-testid="cookie-notice"
          role="dialog"
          aria-live="polite"
          initial={{ y: 40, opacity: 0 }}
          animate={{ y: 0, opacity: 1, transition: { delay: pathname === "/" ? 2.4 : 0.4, duration: 0.7, ease: [0.22, 1, 0.36, 1] } }}
          exit={{ y: 30, opacity: 0, transition: { duration: 0.35 } }}
          className="fixed inset-x-3 z-[70] mx-auto max-w-md rounded-[24px] border border-white/10 bg-surface/90 p-4 shadow-[0_24px_60px_-20px_rgba(0,0,0,0.8)] backdrop-blur-xl sm:inset-x-auto sm:right-6"
          style={{ bottom: "max(0.75rem, env(safe-area-inset-bottom))" }}
        >
          <div className="flex gap-3">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-gold/30 bg-gold/10">
              <Cookie className="h-4 w-4 text-gold" />
            </span>
            <p className="text-[13px] leading-relaxed text-zinc-300" data-testid="cookie-notice-text">
              {t.cookie.text}{" "}
              <Link to="/privacy-policy" data-testid="cookie-notice-privacy-link" className="text-gold underline-offset-4 hover:underline">
                {t.cookie.link}
              </Link>
            </p>
          </div>
          <button
            onClick={accept}
            data-testid="cookie-notice-accept"
            className="mt-3 h-10 w-full rounded-full bg-gold text-sm font-semibold text-ink transition-opacity hover:opacity-90"
          >
            {t.cookie.ok}
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
